import { NativeStackScreenProps } from '@react-navigation/native-stack'
import { Box, useTheme } from 'native-base'
import React from 'react'
import HoursReportComponent from '../components/HoursReportComponent'
import { RootStackProps } from './Home'

type Props = NativeStackScreenProps<RootStackProps, 'HoursReport'>;

const HoursReport = ({ navigation }: Props) => {
  const { colors } = useTheme()

  return (
    <Box style={{ backgroundColor: colors.primary[50] }}>
      <HoursReportComponent navigation={navigation} />
    </Box>
  )
}

export default HoursReport
